import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ClassGroupPenaltiesCard @event={{@model}}/>",{ moduleName: "bullitt-time-results/templates/event/fis/penalties.hbs" })